import Axios from 'axios';
import HttpStatus from 'http-status-codes';
import _ from 'lodash';
import AuthEndpoints from './AuthEndpoints';
import { store } from '../redux/store';
import { replace } from 'connected-react-router';
import { EventEmitter } from 'events';
//import * as Sentry from '@sentry/browser';

var _token = '';
var _token_locked = false;
var _role = 'Anonymous';

if (localStorage.getItem("auth_token")) {
    _token = localStorage.getItem("auth_token");
}

if (localStorage.getItem("token_locked") === 'true') {
    _token_locked = true;
}

if (localStorage.getItem("role")) {
    _role = localStorage.getItem("role");
}

export const base_url = '/api';
export var token = _token;
export var role = _role;

export const AuthEvents = new EventEmitter();

class Api {
    static setToken(new_token) {
        token = new_token;
        localStorage.setItem("auth_token", token)
    }

    static async login(username, password, otp = {}, additionalParams = {}) {
        var result = await this.post(AuthEndpoints.login, { ...additionalParams, username, password, mfa_otp: (otp.mfa || ""), email_otp: (otp.email || ""), sms_otp: (otp.sms || "") }, 1, false);
        token = result.data.token;
        _token_locked = false;
        role = result.data.role;

        console.debug(result.data);

        localStorage.setItem("auth_token", token);
        localStorage.setItem("token_locked", _token_locked)
        localStorage.setItem("role", role);
        
        if(result)
            AuthEvents.emit("loggedIn", result.data);
        //debugger;
        return result;
    }

    static loggedIn(api_token, api_role, response) {
        token = api_token;
        role = api_role;
        _token_locked = false;

        localStorage.setItem("auth_token", api_token);
        localStorage.setItem("token_locked", false)
        localStorage.setItem("role", api_role);

        AuthEvents.emit("loggedIn", response);
        // Sentry.setUser({
        //     id: response.user.id,
        //     email: response.user.emailaddress
        // })
    }

    static signout(lock_only = true) {
        _token_locked = lock_only;
        localStorage.setItem("token_locked", _token_locked)
        if (!lock_only) {
            this.setToken('');
        }

        AuthEvents.emit("loggedOut");
        //Sentry.setUser(null)
    }

    static isLoggedIn() {
        return token ? true : false;
    }

    static isLocked() {
        return token && _token_locked ? true : false;
    }

    static async get(endpoint, query_params, version = 1, auth = true) {
        console.debug(
            "[GET] ", base_url + `/v${version}/` + endpoint +
            (query_params ? "?" + _.map(query_params, (x, n) => (x ? n + '=' + encodeURIComponent(x.toString()) : "")).join('&') : ""),
            '\n"Authorization" : "Bearer ' + token + '"'
        );
        try {
            var result = await Axios.get(
                base_url + `/v${version}/` + endpoint +
                (query_params ? "?" + _.map(query_params, (x, n) => (x ? n + '=' + encodeURIComponent(x.toString()) : "")).join('&') : ""),
                { headers: (auth ? { Authorization: "Bearer " + token } : {}) }
            );
            console.debug(`[Success] (${result.request.status}) ${base_url + `/v${version}/` + endpoint}\n${JSON.stringify(result.data, null, 4)}`);
            return result;

        } catch (e) {
            console.debug('API GET Request Failed:', JSON.stringify(e, null, 4));

            if (
                (
                    e.request.status === HttpStatus.UNAUTHORIZED //Require Login
                    ||
                    e.request.status === HttpStatus.FORBIDDEN //Require Higher Roles - Go To Login
                ) && auth
            ) {
                _token_locked = true;
                localStorage.setItem("token_locked", _token_locked)
                //TODO: Set - returnUrl
                store.dispatch(replace('/lockedOut'));
            }
            else
                throw e;
        }
    }

    static async fileUpload(endpoint, fileArray, body, version = 1, auth = true) {
        console.debug("[POST (File Upload)] ", base_url + `/v${version}/` + endpoint, '\n"Authorization" : "Bearer ' + token + '"');
        try {
            var form_files = new FormData();

            for (var f = 0; f < fileArray.length; f++)
                form_files.append("file" + f, fileArray[f]);

            _.forEach(body, (x, k) => {
                if (typeof (x) === "object" || typeof (x) === "function") {
                    console.error(`Object in Request [${k}]: Has an invalid Form Data value, must be primitive value - ${x}`);

                    if (typeof (x) === "object")
                        form_files.append(k, JSON.stringify(x))
                }
                else
                    form_files.append(k, x)
            })

            var result = await Axios.post(
                base_url + `/v${version}/` + endpoint,
                form_files,
                { headers: { ...(auth ? { Authorization: "Bearer " + token } : {}), ...{ "Content-Type": "multipart/form-data" } } }
            )

            console.debug(`[Success] (${result.request.status}) ${base_url + `/v${version}/` + endpoint}`);

            return result;
        } catch (e) {
            console.debug('API POST (File Upload) Request Failed:', JSON.stringify(e, null, 4));

            if (
                (
                    e.request.status === HttpStatus.UNAUTHORIZED //Require Login
                    ||
                    e.request.status === HttpStatus.FORBIDDEN //Require Higher Roles - Go To Login
                ) && auth
            ) {
                _token_locked = true;
                localStorage.setItem("token_locked", _token_locked)
                //TODO: Set - returnUrl
                store.dispatch(replace('/lockedOut'));
            }
            else
                throw e;
        }
    }

    static async fileDownload(endpoint, query_params, version = 1, auth = true) {
        console.debug(
            "[GET] ", base_url + `/v${version}/` + endpoint +
            (query_params ? "?" + _.map(query_params, (x, n) => (x ? n + '=' + encodeURIComponent(x.toString()) : "")).join('&') : ""),
            '\n"Authorization" : "Bearer ' + token + '"'
        );
        try {
            var result = await Axios.get(
                base_url + `/v${version}/` + endpoint +
                (query_params ? "?" + _.map(query_params, (x, n) => (x ? n + '=' + encodeURIComponent(x.toString()) : "")).join('&') : ""),
                { headers: (auth ? { Authorization: "Bearer " + token } : {}), responseType: 'blob' }
            );
            console.debug(`[Success] (${result.request.status}) ${base_url + `/v${version}/` + endpoint}`);
            return result;

        } catch (e) {
            console.debug('API GET Request Failed:', JSON.stringify(e, null, 4));

            if (
                (
                    e.request.status === HttpStatus.UNAUTHORIZED //Require Login
                    ||
                    e.request.status === HttpStatus.FORBIDDEN //Require Higher Roles - Go To Login
                ) && auth
            ) {
                _token_locked = true;
                localStorage.setItem("token_locked", _token_locked)
                //TODO: Set - returnUrl
                store.dispatch(replace('/lockedOut'));
            }
            else
                throw e;
        }
    }

    static async post(endpoint, body, version = 1, auth = true) {
        console.debug("[POST] ", base_url + `/v${version}/` + endpoint, '\n"Authorization" : "Bearer ' + token + '"', '\n' + JSON.stringify(body, null, 4));
        try {
            var result = await Axios.post(
                base_url + `/v${version}/` + endpoint,
                body,
                { headers: auth ? { Authorization: "Bearer " + token } : {} }
            )

            console.debug(`[Success] (${result.request.status}) ${base_url + `/v${version}/` + endpoint}\n${JSON.stringify(result.data, null, 4)}`);

            return result;
        } catch (e) {
            console.debug('API POST Request Failed:', JSON.stringify(e, null, 4));

            if (
                (
                    e.request.status === HttpStatus.UNAUTHORIZED //Require Login
                    ||
                    e.request.status === HttpStatus.FORBIDDEN //Require Higher Roles - Go To Login
                ) && auth
            ) {
                _token_locked = true;
                localStorage.setItem("token_locked", _token_locked)
                //TODO: Set - returnUrl
                store.dispatch(replace('/lockedOut'));
            }
            else
                throw e;
        }
    }

    // static socket(endpoint) {
    //     return (
    //         new signalR.HubConnectionBuilder()
    //         .withUrl(endpoint, 
    //             { 
    //                 accessTokenFactory: () => token, 
    //                 logMessageContent: false, 
    //                 transport: signalR.HttpTransportType.LongPolling //TODO: Investigate Issue with WebSockets
    //             }
    //         )
    //         .configureLogging(signalR.LogLevel.None)
    //         .build()
    //     );
    // }
}

export default Api;
